// Configuração do EmailJS com variáveis de ambiente
export const EMAILJS_CONFIG = {
  SERVICE_ID: process.env.REACT_APP_EMAILJS_SERVICE_ID || 'YOUR_SERVICE_ID',
  TEMPLATE_ID: process.env.REACT_APP_EMAILJS_TEMPLATE_ID || 'YOUR_TEMPLATE_ID',
  PUBLIC_KEY: process.env.REACT_APP_EMAILJS_PUBLIC_KEY || 'YOUR_PUBLIC_KEY',
  TEST_EMAIL: process.env.REACT_APP_TEST_EMAIL || 'your-email@example.com',
};

// Template de e-mail padrão
export const EMAIL_TEMPLATE = {
  subject: 'Novo contato via Avoprime',
  to: EMAILJS_CONFIG.TEST_EMAIL,
  from: 'noreply@avoprime.com.br',
};

// Configurações de segurança
export const SECURITY_CONFIG = {
  MAX_ATTEMPTS_PER_HOUR: parseInt(
    process.env.REACT_APP_MAX_ATTEMPTS_PER_HOUR || '10'
  ),
  RATE_LIMIT_WINDOW: parseInt(
    process.env.REACT_APP_RATE_LIMIT_WINDOW || '3600000'
  ), // 1 hora em ms
  ENABLE_CAPTCHA: process.env.REACT_APP_ENABLE_CAPTCHA === 'true',
};
